import { trust } from '@finn-no/trust-web-sdk-finn';
import { Button } from '@warp-ds/react';
import { type Ref, useEffect, useRef, useState } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import { ErrorBoundary } from 'shared/util/ErrorBoundary';
import { focusElementByRef, scrollToElementByRef } from '@/lib/helpers/scroll';

type RatingDesktopProps = {
    adId: number;
    ratingRef?: Ref<HTMLElement>;
};

export const RatingDesktop = ({ adId, ratingRef }: RatingDesktopProps) => {
    const { trustFeedbackApiUrl } = useConfig();
    const [trustFailed, setTrustFailed] = useState(false);

    const reputationWidget = useRef(null);

    const onClick = () => {
        scrollToElementByRef(ratingRef);
        focusElementByRef(ratingRef);
    };

    useEffect(() => {
        const settings = {
            itemSDRN: `sdrn:finn:classified:${adId}`,
            apiUrl: trustFeedbackApiUrl,
            locale: 'nb-NO',
            onError: (e: Error) => {
                setTrustFailed(true);
                if (!e.toString().includes('Response status: 404')) {
                    console.error(`Problems with showing ratings for ${adId}`, e);
                }
            },
        };

        if (reputationWidget.current) {
            trust.itemReputation.run(reputationWidget.current, settings);
        }
    }, [trustFailed, adId]);

    return (
        <ErrorBoundary>
            <div className="objectRatingWidgetDesktop">
                {!trustFailed && (
                    <>
                        <div className="mb-8" ref={reputationWidget} data-trust-item-reputation-widget="placeholder" />
                        <Button link onClick={onClick}>
                            Se alle vurderinger
                        </Button>
                    </>
                )}
            </div>
        </ErrorBoundary>
    );
};
